function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { Text as RNText, Platform } from 'react-native';
import { fontFamily } from '@dkrm/general-libs/theme/fonts';
import { stylePropTypes } from '@dkrm/general-libs/theme/styles';
import { getStyleTheme } from '../theme';
export default class Text extends React.Component {
  getRef() {
    return this.ref;
  }
  render() {
    const {
      style,
      theme,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      className,
      children,
      ...rest
    } = this.props;
    const styleTheme = getStyleTheme(theme);

    // make text can receive className for web, e.g for styling link-like text
    if (Platform.OS === 'web') {
      if ((h1 || h2 || h3 || h4 || h5 || h6) && !rest.accessibilityRole) {
        rest.accessibilityRole = 'heading';
        if (h1) rest['aria-level'] = 1;else if (h2) rest['aria-level'] = 2;else if (h3) rest['aria-level'] = 3;else if (h4) rest['aria-level'] = 4;else if (h5) rest['aria-level'] = 5;else if (h6) rest['aria-level'] = 6;
      }
      rest.className = className;
    }
    return /*#__PURE__*/React.createElement(RNText, _extends({}, rest, {
      ref: ref => {
        this.ref = ref;
      },
      style: [styleTheme, {
        fontFamily
      }, style]
    }), children);
  }
}
Text.defaultProps = {
  theme: '',
  style: null,
  h1: false,
  h2: false,
  h3: false,
  h4: false,
  h5: false,
  h6: false,
  className: null
};
Text.propTypes = process.env.NODE_ENV !== "production" ? {
  // ...RNText.propTypes,
  theme: PropTypes.string,
  style: stylePropTypes,
  h1: PropTypes.bool,
  h2: PropTypes.bool,
  h3: PropTypes.bool,
  h4: PropTypes.bool,
  h5: PropTypes.bool,
  h6: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired
} : {};